module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/gcods/gcods.component.scss
// module id = ./src/app/gcods/gcods.component.scss
// module chunks = main